class GoldFabricsWhatsApp extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    const details = this.querySelector('details');
    const launcher = this.querySelector('summary');
    if (!details || !launcher) return;
    const close = (restoreFocus = false) => {
      details.open = false;
      if (restoreFocus) launcher.focus();
    };
    this.querySelector('.gf-whatsapp__close')?.addEventListener('click', () => close(true), options);
    document.addEventListener('pointerdown', (event) => {
      if (details.open && !event.composedPath().includes(this)) close();
    }, options);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) close(this.contains(document.activeElement));
    }, options);
    document.addEventListener('theme-drawer:open', () => close(), options);
  }
  disconnectedCallback() { this.#controller?.abort(); }
}
if (!customElements.get('gf-whatsapp-widget')) customElements.define('gf-whatsapp-widget', GoldFabricsWhatsApp);
